// Conferences highlighting (also in menu.js!)
// $(function () {
//   $('body').find('li.botswana.current-menu-ancestor').parents('.current-page-ancestor').addClass('botswana');
// });
